import { render, staticRenderFns } from "./ChangelogEntryView.vue?vue&type=template&id=37def763&scoped=true"
import script from "./ChangelogEntryView.vue?vue&type=script&lang=js"
export * from "./ChangelogEntryView.vue?vue&type=script&lang=js"
import style0 from "./ChangelogEntryView.vue?vue&type=style&index=0&id=37def763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37def763",
  null
  
)

export default component.exports